import { ACTION_REWARD_HISTORY_INFO, ACTION_REWARD_HISTORY_INFO_ERROR, ACTION_REWARD_HISTORY_INFO_SUCCESS } from "."
import * as api from "../../../api"
import * as authActions from "../../auth/actions";

export const getRewardHistoryInfoRequest = (access_token, url) => ({
    type: ACTION_REWARD_HISTORY_INFO,
    payload: {
        access_token,
        url
    }
})

export const getRewardHistoryInfoSuccess = data => ({
    type: ACTION_REWARD_HISTORY_INFO_SUCCESS,
    payload: {
        data
    }
})


export const getRewardHistoryInfoError = (msg) => ({
    type: ACTION_REWARD_HISTORY_INFO_ERROR,
    payload: {
        msg
    }
})

export const getRewardHistoryInfo = (access_token, url) => {
    return dispatch => {
        dispatch(getRewardHistoryInfoRequest(access_token, url))
        api.getRewardHistoryInfo(access_token, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(getRewardHistoryInfoError("error"));
                    return
                }

                const {friends, reward} = data
                dispatch(getRewardHistoryInfoSuccess({friends, reward}));
            }).catch((err) => {

                console.log(err)

                if (err.response) {
                    if (err.response.status === 401) {
                        dispatch(authActions.logout())
                        return
                    }
                }

                dispatch(getRewardHistoryInfoError("system error"))
            });
    }
}